import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import factorsCriteriaServices from "./factorsCriteria.services";

export const getFactorsCriteria = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_FACTORSCRITERIA,
      payload: true,
    });
    const resp = await factorsCriteriaServices.getFactorsCriteria(filters);
 
    dispatch({
      type: actions.GET_FACTORSCRITERIA,
      payload: {
        factorsCriteria: resp.data.data,
        factorsCriteriaLenght: resp.data.count
      }
    });
    dispatch({
      type: actions.FACTORSCRITERIA_FAIL,
      payload: null,
    });
    dispatch({
      type: actions.FORM_FACTORSCRITERIA_FAIL,
      payload: null,
    });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.FACTORSCRITERIA_FAIL,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_FACTORSCRITERIA,
      payload: false,
    });
  }
}

export const getFactorCriterion = id => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_FACTORCRITERION,
      payload: true,
    });
    const resp = await factorsCriteriaServices.getFactorCriterion(id);
    dispatch({
      type: actions.GET_FACTORCRITERION,
      payload: resp.data,
    });
    dispatch({
      type: actions.FACTORCRITERION_FAIL,
      payload: null,
    });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.FACTORCRITERION_FAIL,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_FACTORCRITERION,
      payload: false,
    });
  }
}

export const saveFactorCriterion = (req, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_FACTORCRITERION,
      payload: true,
    });

    const resp = await factorsCriteriaServices.saveFactorCriterion(req);
    const { factorsCriteria } = getState().descriptorFactorCriterion;

    dispatch({
      type: actions.GET_FACTORSCRITERIA,
      payload: {
        count: factorsCriteria.count + 1,
        data: [...factorsCriteria.data, resp.data]
      },
    });

    dispatch({
      type: actions.FORM_FACTORSCRITERIA_FAIL,
      payload: null,
    });

    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });

    setShowModal(false);

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_FACTORSCRITERIA_FAIL,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_FACTORCRITERION,
      payload: false,
    });
  }
}

export const editFactorCriterion = (req,id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_FACTORCRITERION,
      payload: true,
    });
    const resp = await factorsCriteriaServices.editFactorCriterion(id, req);
    const { factorsCriteria, factorsCriteriaLenght } = getState().descriptorFactorCriterion;
    factorsCriteria[index] = resp.data[0];

    dispatch({
      type: actions.GET_FACTORSCRITERIA,
      payload: {
        factorsCriteria: factorsCriteria,
        factorsCriteriaLenght: factorsCriteriaLenght

      },
    });
    dispatch({
      type: actions.FORM_FACTORSCRITERIA_FAIL,
      payload: null,
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });


  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_FACTORSCRITERIA_FAIL,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_FACTORCRITERION,
      payload: false,
    });
  }
}

export const deleteFactorCriterion = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_FACTORSCRITERIA,
      payload: true,
    });
    await factorsCriteriaServices.deleteFactorCriterion(id);
    const { factorsCriteria } = getState().descriptorFactorCriterion;
    let _factorsCriteria = factorsCriteria.data.slice();
    _factorsCriteria.splice(index, 1);
    dispatch({
      type: actions.GET_FACTORSCRITERIA,
      payload: {
        data: _factorsCriteria,
        count: factorsCriteria.count - 1
      }
    });
    dispatch({
      type: actions.FACTORSCRITERIA_FAIL,
      payload: null,
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    // dispatch({
    //   type: actions.FACTORSCRITERIA_FAIL,
    //   payload: message
    // })
    toastr.error(message, '', {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADER_FACTORSCRITERIA,
      payload: false,
    });
  }
}